




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import formatScore from '../../../utils/format-score';

@Component({})
class TableRow extends Vue {
  @Prop() rank: number;
  @Prop() name: string;
  @Prop() members: number;
  @Prop() average: number;
  @Prop() total: number;
  @Prop() highlight: boolean;
  @Prop() top: boolean;

  tooltipDisabled = !this.top;

  get tooltipId() {
    return `show-surrounding-members${this.rank}`;
  }

  get pageToGo() {
    let perpage = 20;
    if (this.$route.query.perpage) {
      perpage = Number(this.$route.query.perpage);
    }
    return Math.ceil(this.rank / perpage);
  }

  switchPage() {
    if (this.rank <= 10000) {
      this.$emit('switchpage', this.pageToGo);
    }
  }

  formatScore(score: number): string {
    return formatScore(score, true, { minimumFractionDigits: 1 });
  }
}
export default TableRow;
